






















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import { getFocusList, cancelFocus } from '@/api/videoDevice/index'

@Component({
  components: { ViewDialog }
})
export default class FocusVideoPoints extends Vue {
  @Prop({ default: null })
  public close!: () => void

  public name = 'FocusVideoPoints'
  public showDialog: boolean = false
  public listLoading: boolean = false
  public list: any = []

  public $refs!: {
  }
  public mounted() {
    window.eventBus.$on('openFocusVideoPoints', () => {
      this.showDialog = true
      this.dataChanged = false
      this.fetchData()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openFocusVideoPoints')
  }
  public dataChanged: boolean = false
  public closeDialog() {
    this.showDialog = false
    if (this.dataChanged && this.close) {
      this.close()
    }
  }
  //数据加载
  public fetchData() {
    this.listLoading = true
    getFocusList().then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data
      }
      this.listLoading = false
    })
  }
  public cancelFocus(index: number) {
    var item = this.list[index]
    if (item.IsFocus) {
      cancelFocus(item.Id).then(() => {
        this.dataChanged = true
        item.IsFocus = false
        this.$message({ type: 'success', message: '已取消关注!' })
        this.list.splice(0, index)
      })
    }
  }
}
